import React from 'react';

import styles from './Step.scss';

export type StepProps = {
  description: string;
  image: {
    alt: string;
    avif: [string, string];
    height: number;
    jpg: string;
    webp: string;
    width: number;
  };
  ref: React.RefObject<HTMLDivElement> | ((ref: HTMLDivElement | null) => void);
  title: string;
};

export const Step = (
  {
    description,
    image,
    ref,
    title,
  }: StepProps,
) => (<div ref={ref} className={styles.component} data-testid='howItWorksStep'>
  <picture>
    <source srcSet={`${image.avif[1]} 2x, ${image.avif[0]} 1x`} type="image/avif" />
    <source srcSet={image.webp} type="image/webp" />
    <img alt={image.alt} height={image.height} loading="lazy" src={image.jpg} width={image.width} />
  </picture>
  <div className={styles.content}>
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
</div>);
